var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 7.5,
    fill: "white",
    stroke: "#DEDEDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.25 23.25H32.5C34.1569 23.25 35.5 24.5931 35.5 26.25V36.375H30.25V23.25Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.667 22.668L32.1746 23.4202C33.7767 23.9009 34.5777 24.1412 35.039 24.7612C35.5003 25.3812 35.5003 26.2176 35.5003 27.8901V36.668",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 36.6654V18.8355C14.5 15.9063 14.5 14.4417 15.423 13.715C16.3461 12.9883 17.7053 13.3828 20.4238 14.1719L26.2571 15.8651C27.8975 16.3413 28.7178 16.5794 29.1922 17.2283C29.6667 17.8772 29.6667 18.761 29.6667 20.5287V36.6654",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 36.6654V18.8355C14.5 15.9063 14.5 14.4417 15.423 13.715C16.3461 12.9883 17.7053 13.3828 20.4238 14.1719L26.2571 15.8651C27.8975 16.3413 28.7178 16.5794 29.1922 17.2283C29.6667 17.8772 29.6667 18.761 29.6667 20.5287V36.6654",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.333 21.5H23.833M20.333 26.1667H23.833",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0003 36.6654V33.1654C25.0003 32.0654 25.0003 31.5155 24.6586 31.1737C24.3169 30.832 23.7669 30.832 22.667 30.832H21.5003C20.4004 30.832 19.8504 30.832 19.5087 31.1737C19.167 31.5155 19.167 32.0654 19.167 33.1654V36.6654",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 36.668H36.6663",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogo);
export default __webpack_public_path__ + "static/media/company-logo.637b6550d16229a3b040c0117c63a339.svg";
export { ForwardRef as ReactComponent };